<template>
  <div v-if="visible" class="flex flex-row w-3/3 border border-gray-300 rounded-lg p-2 bg-white shadow-md mt-3">
    <div :class="namedResource ? 'w-1/5': 'w-3/5'">
      <img :src="getImagePreview(image, isUrl)" class="inline-block h-28" alt="">
    </div>
    <div class="w-2/5 " v-if="namedResource">
      <div class="inline-block m-2 w-4/5">
        <div class="flex flex-row w-full text-blue font-bold">{{ $t('image') }}
          {{ indexResource }}
        </div>
        <b-input v-if="image && !isGantt" v-model="image.name" type="is-primary" :placeholder="$t('name_image')"></b-input>
        <b-input v-if="image && isGantt" v-model="image.details" type="textarea" rows="2" :placeholder="$t('details')"></b-input>
      </div>
    </div>

    <div v-if="image && image.image" class="w-2/5 m-2 flex items-center" style="">
      <div class="w-4/5">
        <b-button type="is-danger" @click="deleteResource" class="w-full">
          <b-icon pack="fas" icon="trash-alt"></b-icon>
          <span>{{ $t('remove') }}</span>
        </b-button>
      </div>
    </div>

    <div v-else class="w-2/5 m-2 flex flex-col justify-center" style="">
      <div class="w-4/5 mt-2" v-if="typeResource === 'drawing'">
        <b-button type="is-primary" @click="() => { $emit('epc-show-select-resource-modal', typeResource) }" class="w-full">
          <b-icon pack="fas" icon="search"></b-icon>
          <span>{{ $t('select_drawing') }}</span>
        </b-button>
      </div>

      <div class="w-4/5" v-if="typeResource === 'image'">
        <b-button type="is-primary" @click="() => { $emit('epc-upload-resource', typeResource) }" class="w-full">
          <b-icon pack="fas" icon="upload"></b-icon>
          <span>{{ $t('upload_image') }}</span>
        </b-button>
      </div>

      <!-- Botón para seleccionar una captura guardada del Gantt -->
      <div class="w-4/5 mt-2" v-if="isGantt">
        <b-button type="is-primary" @click="openSelectCapturesModal()" class="w-full">
          <b-icon pack="fas" icon="images"></b-icon>
          <span>{{ $t('select_gantt_capture') }}</span>
        </b-button>
      </div>

      <div class="w-4/5 mt-2" v-if="!isGantt">
        <b-button type="is-primary"
          @click="() => { $emit('epc-show-select-resource-modal', typeResource === 'drawing' ? 'drawingActivity' : typeResource) }" class="w-full">
          <b-icon pack="fas" icon="search"></b-icon>
          <span>{{ $t('select_from_activity') }}</span>
        </b-button>
      </div>
    </div>

    <!-- Modal de capturas del Gantt -->
    <b-modal :active.sync="showCapturesModal" scroll="keep" :width="720">
      <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 p-4">
        <h3 class="text-lg font-bold mb-3">{{ $t('select_gantt_capture') }}</h3>
        <div class="flex flex-wrap gap-3 justify-center">
          <div v-for="(capture, idx) in ganttCaptures" :key="idx"
            class="cursor-pointer border-2 border-gray-200 rounded-lg p-2 hover:border-blue-500 transition-colors"
            style="width: 210px;"
            @click="selectCapture(capture)">
            <img :src="capture.url" :alt="$t('gantt_capture')" class="w-full rounded" style="height: 120px; object-fit: cover;" />
            <p class="text-center text-sm text-gray-600 mt-1">{{ capture.date }}</p>
          </div>
        </div>
        <div v-if="ganttCaptures.length === 0" class="text-center text-gray-500 py-4">
          {{ $t('no_gantt_captures') }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getFromIndexedDb } from '·/utils/indexedDbFileStore'

  export default {
    name: 'view-select-resource',

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      image: {
        type: [String, Object],
        default: null
      },
      typeResource: {
        type: String,
        default: 'image' // o 'drawing'
      },
      isUrl: {
        type: Boolean,
        default: false
      },
      isGantt: {
        type: Boolean,
        default: false
      },
      namedResource: {
        type: Boolean,
        default: false
      },
      indexResource: {
        type: Number,
        default: 1
      }
    },

    data() {
      return {
        showCapturesModal: false,
        ganttCaptures: []
      }
    },

    computed: {
      ...mapGetters({
        project: 'app/project',
      })
    },

    beforeDestroy() {
      this.revokeCaptureUrls();
    },

    methods: {

      getImagePreview(image, isUrl = false) {
        if (!image) {
          return this.asset('public/img_placeholder.png')
        }

        if (typeof image === 'string') {
          image = { image }
        }

        let url = this.asset('public/img_placeholder.png')

        if (image.image) {
          if (image.is_activity_document || isUrl || typeof image.image === 'string') {
            url = image.image
          } else if (image.image instanceof File || image.image instanceof Blob){
            url = URL.createObjectURL(image.image)
          }
        }

        return url
      },

      deleteResource() {
        this.$emit('epc-delete-resource', this.typeResource);
      },

      selectCapture(capture) {
        // Envolvemos el Blob en un File para mantener compatibilidad con el flujo existente
        var file = new File([capture.blob], 'gantt_' + capture.date + '.webp', { type: 'image/webp' });
        var image = { name: 'Gantt ' + capture.date, image: file };
        this.$emit('epc-select-gantt-capture', image);
        this.showCapturesModal = false;
      },

      openSelectCapturesModal() {
        if (!this.project) return;

        getFromIndexedDb('gantt_captures:' + this.project.id)
          .then(captures => {
            // Liberamos los objectURLs anteriores justo antes de reemplazarlos,
            // para que las miniaturas visibles nunca apunten a un blob revocado.
            this.revokeCaptureUrls();
            // Generamos un objectURL por captura solo para mostrar la miniatura.
            this.ganttCaptures = (captures || []).map(c => ({
              date: c.date,
              blob: c.blob,
              url: URL.createObjectURL(c.blob),
            }));
          })
          .catch(() => { this.revokeCaptureUrls(); this.ganttCaptures = []; });

        this.showCapturesModal = true;
      },

      revokeCaptureUrls() {
        this.ganttCaptures.forEach(c => { if (c.url) URL.revokeObjectURL(c.url); });
      },
    }
  };

</script>
